export default[
    {
        show(row, extra) {
            return (
                row.auditstatus === '1' 
                && (!row.auditusername) 
                && (row.orderssum === '0' || row.orderssum === 0)
            )
        },
        tag: 'my-tag',
        type: 'info',
        text(row) {
            return `金额为0，无需操作`;
        }
    },
    {
        show(row, extra) {
            return (
                row.auditstatus === '1' 
                && (!row.auditusername) 
                && (row.orderssum !== '0' && row.orderssum !== 0) 
                && (row.fpbj === "2")
            )
        },
        tag: 'my-tag',
        type: 'success',
        text(row) {
            return `已开发票`;
        }
    },
    {
        show(row, extra) {
            return (
                row.auditstatus === '1' 
                && (!row.auditusername) 
                && (row.orderssum !== '0' && row.orderssum !== 0) 
                && (row.fpbj === "1")
            )
        },
        tag: 'my-tag',
        type: 'primary',
        text(row) {
            return `投标人已申请发票`;
        }
    },
    {
        show(row, extra) {
            return (
                row.auditstatus === '1' 
                && (!!row.auditusername) 
                && (row.orderssum === '0' || row.orderssum === 0)
            )
        },
        tag: 'my-tag',
        type: 'info',
        text(row) {
            return `${row.auditusername}核实`;
        }
    },
    {
        show(row, extra) {
            return (
                row.auditstatus === '1' 
                && (!!row.auditusername) 
                && (
                    row.orderssum !== '0' 
                    && row.orderssum !== 0
                ) 
                && (row.fpbj === "2")
            )
        },
        tag: 'my-tag',
        type: 'success',
        text(row) {
            return `${row.auditusername}核实;已开发票`;
        }
    },
    {
        show(row, extra) {
            return (
                row.auditstatus === '1' 
                && (!!row.auditusername) 
                && (
                    row.orderssum !== '0' 
                    && row.orderssum !== 0
                ) 
                && (row.fpbj === "1")
            )
        },
        tag: 'my-tag',
        type: 'primary',
        text(row) {
            return `${row.auditusername}核实;投标人已申请发票`;
        }
    },
    {
        show(row, extra) {
            return (
                row.auditstatus === '1' 
                && (!!row.auditusername) 
                && (
                    row.orderssum !== '0' 
                    && row.orderssum !== 0
                ) 
                && (row.fpbj === "0" || !row.fpbj)
            )
        },
        tag: 'my-tag',
        type: 'primary',
        text(row) {
            return `${row.auditusername}核实`;
        }
    },
]